module.exports = ".searchGrid-form .btn{\r\n  min-width:unset !important;\r\n  padding:10px!important;\r\n  font-size:12px;\r\n\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/blog-components/blogcategory-list/blogcategory-list.component.css
// module id = ./src/app/blog-components/blogcategory-list/blogcategory-list.component.css
// module chunks = main